import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './containers/Homepage';
import Feature0 from './containers/Feature0';
import Feature1 from './containers/Feature1';
import Feature2 from './containers/Feature2';
import Feature3 from './containers/Feature3';
import Lastpage from './containers/Lastpage';
import Navbar from './containers/Navbar';
import SearchPage from './containers/SearchPage';
import DesignSystem from './containers/DesignSystem';
import './App.css';


const MainContent = () => {
  const sections = ['homepage', 'features', 'feature1', 'feature2', 'feature3', 'lastpage'];
  const texts = [
    'Features', 
    'Next', 
    'Next', 
    'Next', 
    'Last Page',
    'Home Page'
  ];

  const [currentSectionIndex, setCurrentSectionIndex] = useState(1);
  const sectionRefs = useRef(sections.map(() => React.createRef()));

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const index = sections.indexOf(entry.target.id);
          if (index !== -1) {
            setCurrentSectionIndex(index);
          }
          else if ((index === sections.length - 1) || (texts[index] === 'Home Page')) {
            setCurrentSectionIndex(0);
          }
        }
      });
    }, { threshold: 0.5 }); // Trigger when 50% of the section is in view

    sectionRefs.current.forEach(ref => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    return () => {
      sectionRefs.current.forEach(ref => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      });
    };
  }, [sections]);

  // Handler to update the section index and scroll to the next section
  const handleScroll = () => {
    const nextIndex = (currentSectionIndex + 1) % sections.length;
    setCurrentSectionIndex(nextIndex);
    const nextSection = sectionRefs.current[nextIndex].current;
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="App">      
      <Navbar 
        to={sections[currentSectionIndex]} 
        textToDisplay={texts[currentSectionIndex]} 
        onClick={handleScroll} 
      />
      <div ref={sectionRefs.current[0]} id="homepage">
        <Homepage />
      </div>
      <div ref={sectionRefs.current[1]} id="features">
        <Feature0 />
      </div>
      <div ref={sectionRefs.current[2]} id="feature1">
        <Feature1 />
      </div>
      <div ref={sectionRefs.current[3]} id="feature2">
        <Feature2 />
      </div>
      <div ref={sectionRefs.current[4]} id="feature3">
        <Feature3 />
      </div>
      <div ref={sectionRefs.current[5]} id="lastpage">
        <Lastpage />
      </div>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainContent />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/design" element={<DesignSystem />} />
      </Routes>
    </Router>
  );
};

export default App;
